import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { FileText, Zap, Shield, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden mt-[-85px] mb-[-85px]" data-id="element-134" data-mp="9kjxeqt8b84q">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-brand-green/20 blur-[120px] rounded-full pointer-events-none" data-id="element-135" data-mp="4mrt0xbedtjn" />

      <div className="container mx-auto px-4 relative z-10 pt-[35px] pb-[35px] mt-[-35px]" data-id="element-136" data-mp="xae7j0m5yila">
        <div className="max-w-4xl mx-auto text-center" data-id="element-137" data-mp="x8jjhdfliacz">
          {/* Brand Name - Prominent */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="md:mb-10 mb-[15px]" data-id="element-138" data-mp="sd4c94c3fcpj">
            <span className="inline-flex items-center gap-2 text-brand-light font-bold sm:text-3xl md:text-4xl tracking-wider text-[18px] mt-[-40px] mb-[-24px] font-[Poppins,_sans-serif]" data-id="element-139" data-mp="3j8selyn99fos">
              🌿 BIOMA LÍVIDO™
            </span>
          </motion.div>

          {/* Main Headline */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="mb-5 md:mb-8" data-id="element-140" data-mp="3e9607lvoxtee">
            <h1 className="sm:text-5xl md:text-6xl lg:text-7xl font-bold md:mb-2 mt-[-10px] mb-[-45px] pt-[5px] pb-[5px] font-[Poppins,_sans-serif] text-[22px]" data-id="element-141" data-mp="2qkwml78msbyc">
              Terminá con la hinchazón, recuperá tu energía y volvé a comer sin
              culpa en <span className="text-brand-light" data-id="element-142" data-mp="2lkqz839e9bm2">21 días.</span>
            </h1>
          </motion.div>

          {/* Product Mockup Image */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="relative max-w-[16rem] md:max-w-lg mx-auto mb-5 md:mb-12" data-id="element-143" data-mp="s3349bcaykwh">
            <img src="https://cdn.magicpatterns.com/uploads/jFKcFRzqoDte6q4tEzqDzh/Mockup_-_Sistema_Rescate_Intestinal_(1x1).webp" alt="Sistema Rescate Intestinal +55 Mockup" width={1024} height={1024} loading="eager" fetchPriority="high" decoding="async" className="w-full h-auto drop-shadow-2xl md:mt-[-35px] md:mb-[-35px] mt-[-30px] mb-[-30px] pt-[10px] pb-[10px]" data-id="element-144" data-mp="1b1ffd2mry4up" />
          </motion.div>

          {/* Subtitle & Description */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="mb-4 md:mb-6" data-id="element-145" data-mp="3htgaib55cpjx">
            <h2 className="text-brand-gold font-bold sm:text-xl md:text-2xl mb-3 md:mb-4 text-[16px]" data-id="element-146" data-mp="2b196kpk45sy6">
              SISTEMA RESCATE INTESTINAL +55™
            </h2>
            <p className="sm:text-base md:text-lg text-gray-200 px-2 max-w-2xl mx-auto mt-[-10px] mb-[-10px] text-[13px]" data-id="element-147" data-mp="2g258wyoth71h">
              El primer sistema de modulación intestinal para la mujer argentina
              de más de 55 años que ya probó de todo y todavía no encontró la
              respuesta real.
            </p>
          </motion.div>

          {/* Feature Badges */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="flex flex-wrap justify-center gap-2 md:gap-3 md:mb-10 text-xs md:text-sm font-medium text-gray-300 mt-[20px] mb-[20px]" data-id="element-148" data-mp="uoaivme0svu8">
            <div className="flex items-center gap-1.5 md:gap-2 bg-brand-dark px-3 md:px-4 py-1.5 md:py-2 rounded-full border border-gray-700" data-id="element-149" data-mp="9aqme8cgbuuw">
              <FileText className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-light" data-id="element-150" data-mp="3hqsco67lzvix" />
              100% PDF
            </div>
            <div className="flex items-center gap-1.5 md:gap-2 bg-brand-dark px-3 md:px-4 py-1.5 md:py-2 rounded-full border border-gray-700" data-id="element-151" data-mp="3cp336v01bpwy">
              <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-gold" data-id="element-152" data-mp="3mp3nok9n4c2q" />
              Acceso en 5 min
            </div>
          </motion.div>

          {/* CTA Button */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="flex flex-col items-center" data-id="element-153" data-mp="2u0po402wl7p2">
            <Button href="#pricing" showBadges className="text-base md:text-xl py-5 md:py-6 px-6 md:px-10 w-full max-w-lg mb-5 md:mb-6 font-bold" data-id="element-154" data-mp="zm2b99lv53sm">
              🌿 QUIERO MI SISTEMA AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-xs md:text-sm text-gray-400" data-id="element-155" data-mp="1x8hxeop8ipmi"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}